import { computed, unref, type Ref } from 'vue'
import { useImagePreview } from '@/hooks/useImagePreview'
import { getFileIcon, handleDownload, isImageFileType } from './tools'

type RecordType = Ref<Partial<ApiFile.Item>> | Partial<ApiFile.Item>

export const useFileMeta = (record: RecordType) => {
  const fileName = computed(() => unref(record)?.fileShowName || unref(record)?.fileName || '未知文件')
  const fileIcon = computed(() => 'icon-' + getFileIcon(unref(record)?.fileExt))

  return {
    fileName,
    fileIcon
  }
}

export const useFileImagePreview = (record: RecordType) => {
  const previewVisible = computed(() => isImageFileType(unref(record)?.fileExt))

  const { preview } = useImagePreview()

  const handlePreview = () => {
    preview(unref(record)?.downloadUrl || '')
  }

  return {
    previewVisible,
    handlePreview
  }
}

export const useFileDownload = (record: RecordType) => {
  const downloadUrl = computed(() => unref(record)?.downloadUrl || '')

  const download = () => {
    handleDownload(downloadUrl.value)
  }

  return {
    downloadUrl,
    download
  }
}
